/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit } from '@angular/core';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import {FormBuilder, FormGroup} from "@angular/forms";
import { TranslationService } from '../../../services/translation.service';

declare var $ : any;
declare var Swal : any;

@Component({
    selector : 'room-item-modal',
    templateUrl:'room-item-modal.html',
    providers  : [],
})
export class RoomItemModal implements OnInit {
  public name;
  public link="";
  public key;
  public description='';
  public timer;
  public editable;
  public thumbnail;
  public video;
  public item
  public linkForm;
  public edit=false;
  public editText="usando"
  public reference;
    public ngOnInit() : any {
    }
    public checkSkills(){
      //check if user has recorded skills
      if (!this._appData.userEventSkills){
        this._companyService.getUserSkills()
      }
    }

    public addItem(){
      let date=new Date();
      let milis=date.getTime()
  
      Swal.fire({
        title: 'Que item deseja criar?',
        html: "<img id='postitImg"+milis+"' src='/assets/game-ui/desk/g31611.png' style='width:50px;height:50px'><img id='docs"+milis+"' src='/assets/game-ui/desk/g31611B.png' style='width:50px;height:50px;margin-left:5px'><img id='excel"+milis+"'  src='/assets/game-ui/desk/g31611C.png' style='width:50px;height:50px;margin-left:5px'><img id='powerpoint"+milis+"' src='/assets/game-ui/desk/g31611D.png' style='width:50px;height:50px;margin-left:5px'><img id='draw"+milis+"' src='/assets/game-ui/desk/g31611E.png' style='width:50px;height:50px;margin-left:5px'>",
        showConfirmButton: false,
        showCancelButton: false,     
      })
      $(document).on('click', '#postitImg'+milis, ()=> {
              let baseitem={
                id:milis,
                event:this._appData.event.id,
                action:'embed',
                name:'postit',
                quantity:1,
                thumbnail:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FeventRecipepostit.png?alt=media&token=8b3f49ad-544b-4ab4-b4b8-a229697b1ebe',
              }				
              let objectId=milis.toString();
              let pos={x:10,y:10,z:0}
              let mapItem={
                objectId:objectId,
                name:baseitem.name,
                collision:false,
                dimensions:{x:16,y:16,z:16},
                room:this._appData.param.room,
                position:pos,
                location:pos,
                action:'embed',
                param:{link:'',name:'postit'}
              }
              mapItem['texture']=baseitem.thumbnail;
              mapItem['thumbnail']=baseitem.thumbnail;     
              mapItem['base']=baseitem; 
              this._companyService.getUserRoomItemRef(this._appData.param.room).doc(mapItem.objectId).set(mapItem).then(val=>{
                this.sendIframeMessage({kind:'addItem',item:mapItem})
                Swal.fire(this.translate.instant('SUCCESS'),'Seu item foi criado e está disponível para uso')
              }); 
      }); 
      $(document).on('click', '#docs'+milis, ()=> {
        this.makeItem('application/vnd.google-apps.document','https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631736382299?alt=media&token=a11531ac-c266-425d-b741-4cd5e1ddbcbb')
      }); 
      $(document).on('click', '#excel'+milis, ()=> {
        this.makeItem('application/vnd.google-apps.spreadsheet','https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631736939295?alt=media&token=e4a85a00-16eb-47a6-964f-85b78ebc5b04')
      }); 
      $(document).on('click', '#powerpoint'+milis, ()=> {
        this.makeItem('application/vnd.google-apps.presentation','https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631737637744?alt=media&token=11071148-0f51-4295-b2cb-06929aec7143')
      }); 
      $(document).on('click', '#draw'+milis, ()=> {
        this.makeItem('application/vnd.google-apps.drawing','https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Foffice%2Fundefined_1631737381584?alt=media&token=44280d7f-3f03-433e-9137-49fdd5c10706')
      }); 
  
  
          
  
  
    }
    public makeItem(type,thumbnail){
            //entrar
            let iframeUrl=this._appData.focusIframe

            $('#RoomItemModal').modal('hide')
            Swal.fire({
              title: 'Selecione o nome do arquivo',
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: 'Salvar',
              showLoaderOnConfirm: true,
              preConfirm: (login) => {
                if (!login){
                  Swal.fire('Erro..','Selecione um nome pro arquivo')
                }
                else{
                  this._appData.focusIframe=iframeUrl
                  $('#RoomItemModal').modal("show")
                  let fileName=login;
                  Swal.fire({
                    title: 'Criando seu arquivo',
                    html: 'Estamos criando seu arquivo. Isso pode demorar um pouco então por favor pedimos que você aguarde com o browser ligado. Ao final do processo o seu arquivo vai aparecer na área de trabalho.',
                  })
                  this._companyService.addNewFileToDrive(this._appData.instagramUser.uid,type,fileName).then(
                    (val)=>{

                      let date=new Date();
                      let milis=date.getTime()
                            let baseitem={
                              id:milis,
                              event:this._appData.event.id,
                              action:'embed',
                              param:{link:val,name:fileName},
                              name:fileName,
                              quantity:1,
                              thumbnail:thumbnail,
                            }				
                            let objectId=milis.toString();
                            let pos={x:10,y:10,z:0}
                            let mapItem={
                              objectId:objectId,
                              name:fileName,
                              collision:false,
                              dimensions:{x:16,y:16,z:16},
                              room:this._appData.param.room,
                              position:pos,
                              location:pos,
                              action:'embed',
                              param:{link:val,name:fileName}
                            }
                            mapItem['texture']=baseitem.thumbnail;
                            mapItem['thumbnail']=baseitem.thumbnail;                   
                            mapItem['base']=baseitem;               
                            this._companyService.getUserRoomItemRef(this._appData.param.room).doc(mapItem.objectId).set(mapItem).then(val=>{
                              this.sendIframeMessage({kind:'addItem',item:mapItem})
                              Swal.fire(this.translate.instant('SUCCESS'),'Seu item foi criado e está disponível para uso')
                            }); 
                    })
                }
              }
          })
      
  

  }
  public saveLink(){
    let link=this.linkForm.controls['actionLink'].value;
    let id=this._appData.param.id;
    let param;
    for (let i=0;i<this._appData.room.roomObjects.length;i++){
      let obj=this._appData.room.roomObjects[i]
      if (obj.objectId==id){
        this._appData.room.roomObjects[i].param.link=link;
        param=this._appData.room.roomObjects[i].param;
      }
    }
    this._companyService.updateRoom(this._appData.room);
    this.link=link;
    this.sendIframeMessage({
      kind:'updateObjectParams',
      param:{objectId:id,param:param}
    });  

  }
  public sendIframeMessage(messageKind){
    var iframe = document.getElementById('roomItemFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
}
public unload(){
  this.link="/iframeBase.html"
  this.name=""
  this._appData.focusIframe="";
  this.reference();
}
public gotoBag(){
  this._appData.object=null;
  $('#jitsi-control-tutorial').click();
  $('#containerModal').modal("show")
  $('#containerModal').draggable({
    handle: ".modal-header"
  });
  $('#containerModalClick').click();
}
  public reload() {
      this.link="/game.html?uid="+this._appData.instagramUser.uid+"&room="+this._appData.param.room+"&lg=pt"
      if (this._appData.isMobile){
        setTimeout(()=>{
          $('#roomItemFrame').css('top','200px')
        },2000)
      }
      this.name=this._appData.param.name
      this._appData.focusIframe="roomItemFrame";
      this.reference=this._companyService.getUserRoomItemRef(this._appData.param.room).where("room","==",this._appData.param.room).onSnapshot((querySnapshot) => {
        var objects = [];
        querySnapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            let obj=change.doc.data();
            this.sendIframeMessage({
              kind:'addItem',
              item:obj
            })
          }
          if (change.type === "modified") {
            let obj=change.doc.data();
            this.sendIframeMessage({
              kind:'updateItem',
              item:obj
            })
          }
          if (change.type === "removed") {
            let obj=change.doc.data();
            this.sendIframeMessage({
              kind:'removeItem',
              item:obj
            })
          }

        });
    });
  }
    constructor( private fb : FormBuilder,public translate: TranslationService,public _appData : AppDataService,public _sanitizer: DomSanitizer,private _companyService : CompanyService) {
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/room-item-modal/room-item-modal.ts